(function(){
  "use strict";

  function initHDrag(el){
    var down=false,startX=0,scrollLeft=0,moved=false;
    el.addEventListener('mousedown',function(e){down=true;moved=false;el.classList.add('grabbing');startX=e.pageX;scrollLeft=el.scrollLeft;});
    window.addEventListener('mouseup',function(){down=false;el.classList.remove('grabbing');});
    el.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();moved=true;el.scrollLeft=scrollLeft-(e.pageX-startX);});
    el.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
  }

  function initHDragAll(root){
    root.querySelectorAll('.ldp-hscroll').forEach(initHDrag);
  }

  function initAccordions(root){
    root.querySelectorAll('.ldp-accordion-head').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest('.ldp-accordion-item');
        var wasOpen=item.classList.contains('open');
        item.parentElement.querySelectorAll('.ldp-accordion-item').forEach(function(i){i.classList.remove('open');i.querySelector('.sym').textContent='+';});
        if(!wasOpen){item.classList.add('open');btn.querySelector('.sym').textContent='\u2212';}
      });
    });
  }

  function initOffers(root){
    var offers=root.querySelectorAll('.ldp-offer');
    var variantInput=root.querySelector('[data-ldp-variant-input]');
    offers.forEach(function(btn){
      btn.addEventListener('click',function(){
        offers.forEach(function(o){o.classList.remove('selected');});
        btn.classList.add('selected');
        var vid=btn.getAttribute('data-variant-id');
        if(variantInput && vid){
          variantInput.value=vid;
          variantInput.dispatchEvent(new Event('change',{bubbles:true}));
        }
        root.querySelectorAll('[data-ldp-compare]').forEach(function(c){c.style.display='none';});
        var idx=btn.getAttribute('data-idx');
        var cmp=root.querySelector('[data-ldp-compare="'+idx+'"]');
        if(cmp) cmp.style.display='inline';
      });
    });
  }

  function initCountdown(root){
    var els=root.querySelectorAll('[data-ldp-countdown]');
    if(!els.length) return;
    function tick(){
      var now=new Date();
      var end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0);
      var diff=Math.max(0,end-now);
      var h=String(Math.floor(diff/3600000)).padStart(2,'0');
      var m=String(Math.floor(diff/60000)%60).padStart(2,'0');
      var s=String(Math.floor(diff/1000)%60).padStart(2,'0');
      els.forEach(function(el){el.textContent=h+':'+m+':'+s;});
    }
    tick();
    setInterval(tick,1000);
  }

  // Generic drag + snap + arrow-driven slider. Works for tracks that already
  // have all their slides in the DOM (mini carousel, testimonials, reviews, videos).
  function initTrackSlider(root, trackSel, prevSel, nextSel, dotsSel, autoplayMs){
    var track = root.querySelector(trackSel);
    if(!track) return;
    var prev = prevSel ? root.querySelector(prevSel) : null;
    var next = nextSel ? root.querySelector(nextSel) : null;
    var dotsWrap = dotsSel ? root.querySelector(dotsSel) : null;
    var paused = false;

    function step(){
      var first = track.children[0];
      if(!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function currentIndex(){
      return Math.round(track.scrollLeft / Math.max(step(),1));
    }
    function updateDots(){
      if(!dotsWrap) return;
      var idx = currentIndex();
      dotsWrap.querySelectorAll('.ldp-dot').forEach(function(d,di){ d.classList.toggle('active', di===idx); });
    }
    function goTo(idx){
      var max = track.children.length - 1;
      idx = Math.max(0, Math.min(max, idx));
      track.scrollTo({ left: idx*step(), behavior:'smooth' });
    }
    if(prev) prev.addEventListener('click', function(){ goTo(currentIndex()-1); });
    if(next) next.addEventListener('click', function(){ goTo(currentIndex()+1); });
    if(dotsWrap){
      dotsWrap.querySelectorAll('.ldp-dot').forEach(function(d,di){ d.addEventListener('click', function(){ goTo(di); }); });
    }
    var scrollTimer;
    track.addEventListener('scroll', function(){
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 80);
    });
    updateDots();

    if(autoplayMs){
      ['touchstart','mousedown'].forEach(function(ev){ track.addEventListener(ev,function(){ paused=true; }); });
      ['touchend','mouseup','mouseleave'].forEach(function(ev){ track.addEventListener(ev,function(){ paused=false; }); });
      setInterval(function(){
        if(paused) return;
        var idx = currentIndex();
        goTo(idx >= track.children.length-1 ? 0 : idx+1);
      }, autoplayMs);
    }
  }

  function initLightbox(root){
    var lb=root.querySelector('.ldp-lightbox');
    if(!lb) return;
    var imgEl=lb.querySelector('img');
    function gallery(){
      return Array.prototype.map.call(root.querySelectorAll('[data-ldp-zoom]'), function(el){ return el.src; });
    }
    var current=0;
    function open(src){
      var g = gallery();
      current=g.indexOf(src);
      if(current<0) current=0;
      imgEl.src=g[current]||src;
      lb.classList.add('open');
    }
    root.addEventListener('click', function(e){
      var el = e.target.closest('[data-ldp-zoom]');
      if(el) open(el.src);
    });
    lb.querySelector('.close').addEventListener('click',function(){lb.classList.remove('open');});
    lb.addEventListener('click',function(e){if(e.target===lb) lb.classList.remove('open');});
    var prevBtn=lb.querySelector('.prev'), nextBtn=lb.querySelector('.next');
    if(prevBtn) prevBtn.addEventListener('click',function(){var g=gallery();current=(current-1+g.length)%g.length;imgEl.src=g[current];});
    if(nextBtn) nextBtn.addEventListener('click',function(){var g=gallery();current=(current+1)%g.length;imgEl.src=g[current];});
  }

  function buildTestimonials(root){
    var track = root.querySelector('[data-ldp-testi-track]');
    if(!track) return;
    var cards = JSON.parse(root.getAttribute('data-ldp-testimonials')||'[]');
    track.innerHTML = cards.map(function(c){
      return '<div class="ldp-testi-slide">'+
        '<img src="'+c.img+'" alt="Testimonio" loading="eager" data-ldp-zoom>'+
        '<p><strong>'+c.lead+'</strong> '+c.body+'</p></div>';
    }).join('');
    var dotsWrap = root.querySelector('[data-ldp-testi-dots]');
    if(dotsWrap) dotsWrap.innerHTML = cards.map(function(_,i){ return '<div class="ldp-dot'+(i===0?' active':'')+'"></div>'; }).join('');
    initTrackSlider(root, '[data-ldp-testi-track]', '[data-ldp-testi-prev]', '[data-ldp-testi-next]', '[data-ldp-testi-dots]');
  }

  function buildReviews(root){
    var track = root.querySelector('[data-ldp-review-track]');
    if(!track) return;
    var reviews = JSON.parse(root.getAttribute('data-ldp-reviews')||'[]');
    track.innerHTML = reviews.map(function(r){
      return '<div class="ldp-review-card">'+
        (r.img?('<img src="'+r.img+'" alt="'+r.name+'" loading="eager" data-ldp-zoom>'):('<div class="avatar"><span>'+(r.name?r.name[0]:'?')+'</span></div>'))+
        '<div class="body"><div class="stars">'+'\u2605'.repeat(r.stars||5)+'</div><p>'+r.text+'</p>'+
        '<div class="meta"><span>'+r.name+(r.city?(' \u00b7 '+r.city):'')+'</span><span class="v">COMPRA VERIFICADA</span></div></div></div>';
    }).join('');
    initTrackSlider(root, '[data-ldp-review-track]', '[data-ldp-review-prev]', '[data-ldp-review-next]', null);
  }

  function initPopup(root){
    var el = document.querySelector('[data-ldp-popup]');
    if(!el) return;
    var buyers = [
      {name:'Jorge',city:'Bogot\u00e1',img:''},
      {name:'Mar\u00eda',city:'Medell\u00edn',img:''},
      {name:'Camila',city:'Cali',img:''},
      {name:'Valentina',city:'Guatemala',img:''}
    ];
    var imgEl = el.querySelector('[data-ldp-popup-img]');
    var txtEl = el.querySelector('[data-ldp-popup-text]');
    var closeBtn = el.querySelector('[data-ldp-popup-close]');
    var testimonials = JSON.parse(root.getAttribute('data-ldp-testimonials')||'[]');
    var closed = false;
    var i = 0;
    function show(){
      if(closed) return;
      var b = buyers[i % buyers.length];
      var t = testimonials[i % testimonials.length];
      if(t && t.img){ imgEl.src = t.img; imgEl.style.display='block'; } else { imgEl.style.display='none'; }
      txtEl.innerHTML = '<b>'+b.name+'</b> desde '+b.city+' compr\u00f3 Lymphatic Drainage hace '+(Math.floor(Math.random()*20)+2)+' minutos';
      el.classList.add('show');
      i++;
      setTimeout(function(){ el.classList.remove('show'); }, 5000);
    }
    closeBtn.addEventListener('click', function(){ closed = true; el.classList.remove('show'); });
    setTimeout(show, 4000);
    setInterval(function(){ if(!el.classList.contains('show')) show(); }, 14000);
  }

  function init(){
    document.querySelectorAll('.ldp[data-ldp-root]').forEach(function(root){
      initHDragAll(root);
      initAccordions(root);
      initOffers(root);
      initCountdown(root);
      buildTestimonials(root);
      buildReviews(root);
      initTrackSlider(root, '.ldp-mini-track', null, null, '.ldp-mini-dots', 4000);
      initTrackSlider(root, '.ldp-video-row', '[data-ldp-video-prev]', '[data-ldp-video-next]', null);
      initLightbox(root);
      initPopup(root);
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else { init(); }
})();
